import * as React from 'react';

export const CustomerSupport: React.FunctionComponent = () => {
  return (
    <section className='customer-support'>
      <h2>{`Customer Support`}</h2>
    </section>
  );
};